import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import CustomTextField from "../../../components/Form/CustomTextField";
const CustomerDetails = ({ isEdit = false, formObj, handleFormObjChange, error }) => {
  const fieldError = (field) => {
    if (error?.code !== "invalid_field") return null;
    const message = error?.errors?.[field];
    return Array.isArray(message) ? message[0] : message;
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <Box>
      <Grid container spacing={1.5}>
        <Grid item xs={12}>
          <CustomTextField title="Customer name" values={formObj.customer_name} onChange={(v) => handleFormObjChange("customer_name", v)} placeholder="Enter customer name" error={fieldError("customer_name")} />
        </Grid>
        <Grid item md={6} xs={12}>
          <CustomTextField
            title={'Phone Number'}
            placeholder={'Phone Number'}
            type={'phone'}
            isOptional={true}
            InputProps={{
              startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
            }}
            values={formObj?.phone}
            onChange={(v) => handleFormObjChange("phone", v)}
            error={fieldError("customer_phone")}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <CustomTextField
            title="Email"
            values={formObj.customer_email}
            isOptional={true}
            onChange={(v) => handleFormObjChange("customer_email", v)}
            placeholder="Enter customer email"
            type="email"
            error={fieldError("customer_email")}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField title="Customer Remarks"
            values={formObj.remarks}
            onChange={(v) => handleFormObjChange("remarks", v)}
            multiline rows={4} placeholder="Add remarks"
            isOptional={true} error={fieldError("remarks")} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomerDetails;
